import { useQuery } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";
import { SUPPORT_USER_BUDGET_STATUS_QUERY_KEY } from "../../../constants/queryKeys";

export const useUserBudgetStatus = (userId) => {
  return useQuery({
    queryKey: [SUPPORT_USER_BUDGET_STATUS_QUERY_KEY, userId],
    queryFn: async () => makeApiRequest({
      endpoint: `/api/support/user-budget-status/${userId}`,
      method: "GET"
    }),
    enabled: !!userId
  });
};
